module.exports = __webpack_public_path__ + "857f0477e7014a3e5fa17f3e5c85e2ef.ttf";